import { makeStyles } from '@material-ui/core';
import AssistantIcon from '@material-ui/icons/Assistant';
import ArchiveIcon from '@material-ui/icons/Archive';
import ChatIcon from '@material-ui/icons/Chat';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DeleteIcon from '@material-ui/icons/Delete';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import PeopleIcon from '@material-ui/icons/People';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import SearchIcon from '@material-ui/icons/Search';
import SettingsIcon from '@material-ui/icons/Settings';
import { Groups } from '@styled-icons/material/Groups';
import { FileEarmarkBinaryFill } from '@styled-icons/bootstrap/FileEarmarkBinaryFill';
import { Organization } from '@styled-icons/fluentui-system-filled/Organization';
import { FileOpen, Workspaces } from '@styled-icons/material';
import { Folder, FolderOpen } from '@styled-icons/boxicons-solid';
import { Circle } from '@styled-icons/boxicons-solid';
import { File } from '@styled-icons/boxicons-regular';
import { DocumentSearch } from '@styled-icons/fluentui-system-filled/DocumentSearch';
import DnsOutlinedIcon from '@material-ui/icons/DnsOutlined';
import { Database } from '@styled-icons/fa-solid/Database';
import UploadContracts from '../../images/menu-icon-upload-contracts-active.svg';
import { Sidebar } from 'styled-icons/boxicons-regular';
import { Key } from '@styled-icons/material-outlined/Key';
import SystemUpdateAltOutlinedIcon from '@material-ui/icons/SystemUpdateAltOutlined';
import { ReactComponent as FileIcon } from '../../images/icons/sidebar/file.svg';
import { ReactComponent as LightBulbIcon } from '../../images/icons/sidebar/lightBulb.svg';
import { ReactComponent as FileSearchIcon } from '../../images/icons/sidebar/fileSearch.svg';
import { ReactComponent as AwardIcon } from '../../images/icons/sidebar/award.svg';
import { ReactComponent as HandshakeIcon } from '../../images/icons/sidebar/handshake.svg';
import { ReactComponent as FileMedicalIcon } from '../../images/icons/sidebar/fileMedical.svg';
import { ReactComponent as ChartLineIcon } from '../../images/icons/sidebar/chartLine.svg';
import { ReactComponent as HeartrateIcon } from '../../images/icons/sidebar/heartRate.svg';
import { ReactComponent as SettingsSVGIcon } from '../../images/icons/sidebar/settings.svg';
import { ReactComponent as UserIcon } from '../../images/icons/sidebar/user.svg';
import { ReactComponent as UserAltIcon } from '../../images/icons/sidebar/userAlt.svg';
import { ReactComponent as UserBusinessIcon } from '../../images/icons/sidebar/userBusiness.svg';
import { ReactComponent as KeyIcon } from '../../images/icons/sidebar/key.svg';
import { ReactComponent as GameStructureIcon } from '../../images/icons/sidebar/gameStructure.svg';
import { ReactComponent as ServerIcon } from '../../images/icons/sidebar/server.svg';
import { ReactComponent as VerticalEllipsisIcon } from '../../images/icons/sidebar/verticalEllipsis.svg';
import { ReactComponent as FileCopySVGIcon } from '../../images/icons/sidebar/fileCopy.svg';
import { ReactComponent as FileTimesIcon } from '../../images/icons/sidebar/fileTimes.svg';
import { ReactComponent as FileBookmarkIcon } from '../../images/icons/sidebar/fileBookmark.svg';

export const compare = (a, b) => {
  let comparison = 0;
  if (a.rank > b.rank) {
    comparison = 1;
  } else if (a.rank < b.rank) {
    comparison = -1;
  }
  if (a.rank === 0) comparison = 1;
  return comparison;
};

const getMenuIconByPageType = (pageType, title, isNewV1Theme) => {
  let Icons;

  let specialPageTypeOverrides;

  if (isNewV1Theme) {
    Icons = {
      congnitivesearch: FileSearchIcon,
      aiassistant: AssistantIcon,
      archive: FileBookmarkIcon,
      delete: FileTimesIcon,
      delegation: GameStructureIcon,
      duplicates: FileCopySVGIcon,
      masterdata: ServerIcon,
      myworkspace: Workspaces,
      pagesdesign: FileIcon,
      procuregpt: ChatIcon,
      search: SearchIcon,
      system: SettingsSVGIcon,
      systemusers: UserIcon,
      systemgroups: UserAltIcon,
      upload: FileIcon,
      systemroles: UserBusinessIcon,
      systemprivileges: Key,
    };

    specialPageTypeOverrides = {
      dashboard: {
        Opportunities: LightBulbIcon,
        'Standard Opportunities': AwardIcon,
        Obligations: HandshakeIcon,
        'Obligation Tracker': FileMedicalIcon,
        Insights: FileSearchIcon,
        'Contract Insights': FileIcon,
        'Spend Insights': ChartLineIcon,
        'Opportunity Insights': LightBulbIcon,
        'Internal Activity': HeartrateIcon,
      },
      group: {
        Contracts: FileIcon,
        Downloads: SystemUpdateAltOutlinedIcon,
      },
    };
  } else {
    Icons = {
      congnitivesearch: DocumentSearch,
      aiassistant: AssistantIcon,
      archive: ArchiveIcon,
      dashboard: DashboardIcon,
      delete: DeleteIcon,
      delegation: Organization,
      duplicates: FileCopyIcon,
      group: Folder,
      masterdata: Database,
      myworkspace: Workspaces,
      others: FileEarmarkBinaryFill,
      pagesdesign: FileIcon,
      procuregpt: ChatIcon,
      search: SearchIcon,
      system: SettingsIcon,
      systemusers: PeopleIcon,
      systemgroups: Groups,
      upload: UploadContracts,
      systemroles: PersonOutlineOutlinedIcon,
      systemprivileges: Key,
    };
  }

  const specialIcon = specialPageTypeOverrides?.[pageType]?.[title];
  if (specialIcon) return specialIcon;

  return Icons?.[pageType] || (isNewV1Theme ? pageType === "dashboard" ? FileIcon : Circle : FolderOpen);
};

const generateMenuInfo = (page, type, initialUrl, isNewV1Theme) => {
  let { name, title, activeIcon, icon, url, _id, rank, labelPage, isLabel, type: pageType } = page;
  pageType = pageType ? pageType.toLowerCase() : 'item';
  let MenuIcon = getMenuIconByPageType(pageType, title, isNewV1Theme);
  let obj = {
    id: name,
    title,
    type,
    pageType,
    open: page.menuOpen || false,
    activeIcon,
    icon,
    MenuIcon,
    url:
      page.selfserviceai || page.directRoute
        ? `/${initialUrl}/${url}`
        : `/${initialUrl}/page/${url}`,
    currentPageUrl: url,
    exact: true,
    muiIcon: icon || activeIcon || pageType !== 'upload', //TODO:
    children: [], //TODO:
    _id: _id,
    rank: rank,
  };
  if (labelPage) obj.parentId = labelPage;
  if (isLabel && labelPage) obj.isLabelAndCild = true;
  return obj;
};

export const generatePendingItems = (items, groups) => {
  let pendingItems = [];
  items.map(item => {
    let isChild = false;
    groups.map(g => {
      if (g._id === item.parentId) {
        isChild = true;
        g.children.push(item);
      }
    });
    if (!isChild) pendingItems.push(item);
  });
  return pendingItems;
};

export const sortedDynamicMenuGroups = groups => {
  let gs = groups.sort(compare);
  gs.map(g => {
    if (g.children.length > 0) {
      g.children = g.children.sort(compare);
    }
  });
  return gs;
};

/**
 * This fucntion will help to merge groups which will be child components of other groups
 */
export const handleGroupsWithLabelPage = groups => {
  let gs = [...groups];
  let deleteIndex = [];
  gs.map((g, dInd) => {
    if (g.isLabelAndCild && g.parentId) {
      gs.map((gl, i) => {
        if (gl._id === g.parentId) {
          gl.children.push(g);
          deleteIndex.push(g._id);
        }
      });
    }
  });
  return gs.filter(i => !deleteIndex.includes(i._id));
};

export const generateDynamicMenuGroups = (initialUrl, ps, isNewV1Theme) => {
  let groups = [],
    items = [];
  ps.filter(i => i && !i.hide).forEach(page => {
    if (page.isLabel) {
      let obj = generateMenuInfo(page, 'group', initialUrl, isNewV1Theme);
      groups.push(obj);
    } else {
      let obj = generateMenuInfo(page, 'item', initialUrl, isNewV1Theme);
      items.push(obj);
    }
  });

  let pendingItems = generatePendingItems(items, groups);

  let groupKeys = {};
  groups.forEach(i => {
    groupKeys[i._id] = true;
  });

  pendingItems = pendingItems.filter(i => (i.parentId ? groupKeys[i.parentId] : true));
  // to hide pages which are part of a group but group is missing

  groups = [...groups, ...pendingItems];

  groups = handleGroupsWithLabelPage(groups);

  groups = sortedDynamicMenuGroups(groups);

  return groups;
};

export const generateDynamicMenu = (initialUrl, pages, isNewV1Theme) => {
  if (pages && pages.length > 0) {
    let ps = [...pages];
    // ps = ps.sort(compare);
    let groups = generateDynamicMenuGroups(initialUrl, ps, isNewV1Theme);
    /*return ps.filter(i => i && !i.hide).map(page => {
			return ({
				'id': page.name,
				'title': page.title,
				'type': page.menuType ?? 'item',
				'activeIcon': page.url === 'upload' ? UploadContracts : DashboardIcon, //TODO:
				'icon': page.url === 'upload' ? UploadContracts : DashboardIcon, //TODO:
				'url': `/${initialUrl}/page/${page.url}`,
				'exact': true,
				muiIcon: page.url !== 'upload', //TODO:
				'children': [], //TODO:
			})
		}) */
    return groups;
  }
  return [];
};

export const intermediateMenuItems = (menuItems, props) => {
  return menuItems.filter(menu => {
    if (
      props.user?.userName !== 'Dsilo Support' &&
      props.user?.orgId === '6194fdb626ca6952a90412b5'
    ) {
      if (
        menu?.id === 'Transaction' ||
        menu?.id === 'Rules Page' ||
        menu?.id === 'Reconciliation'
      ) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  });
};
